// @ts-nocheck
import React from "react";
import * as services from "../Services/services";
import { formatDue } from "../utils/lessonMedia";
import { statusWord } from "../utils/lmsLearner";
import { useLoad, Status, DownloadButton } from "./learningShared";

/*
 * My transcript: every course I've completed (with a certificate each), what I'm part-way through,
 * and older completions imported from AvSight University that have no new course. The PDF and CSV
 * are made by AVS OS and streamed through copilot-api.
 */

const SOURCE_WORDS = { self: "Self-enrolled", imported: "AvSight University", assignment: "Assigned", manual: "Assigned" };

export default function LearningTranscript() {
  const { loading, error, data, reload } = useLoad(() => services.lmsTranscript(), []);
  const nothing = data && data.courses.length === 0 && (data.inProgress || []).length === 0 && (data.history || []).length === 0;

  return (
    <div data-testid="learning-transcript">
      <div className="d-flex flex-wrap gap-2 align-items-start mb-3">
        <DownloadButton kind="transcript-pdf" label="Download PDF" testid="learning-transcript-pdf" icon="fa-solid fa-file-pdf" />
        <DownloadButton kind="transcript-csv" label="Download CSV" testid="learning-transcript-csv" icon="fa-solid fa-file-csv" />
      </div>
      <Status loading={loading} error={error} onRetry={reload} />
      {nothing && (
        <p className="text-body-secondary" data-testid="learning-transcript-empty">
          Nothing on your transcript yet. Courses appear here as you finish them.
        </p>
      )}
      {data && data.courses.length > 0 && (
        <section className="mb-4" aria-labelledby="learning-transcript-done">
          <h2 id="learning-transcript-done" className="h6 text-body-secondary text-uppercase mb-2">
            Completed
          </h2>
          <div className="table-responsive">
            <table className="table table-sm align-middle learning-table">
              <thead>
                <tr>
                  <th scope="col">Course</th>
                  <th scope="col">Completed</th>
                  <th scope="col">How</th>
                  <th scope="col">
                    <span className="visually-hidden">Certificate</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.courses.map((c) => (
                  <tr key={c.courseId} data-testid="learning-transcript-row">
                    <td>{c.courseName}</td>
                    <td className="text-nowrap">{formatDue(c.completedAt)}</td>
                    <td className="text-nowrap">{SOURCE_WORDS[c.source] || "Assigned"}</td>
                    <td className="text-end">
                      {c.certificate && (
                        <DownloadButton
                          kind="certificate"
                          id={c.courseId}
                          fileLabel={c.courseName}
                          label={<>Certificate<span className="visually-hidden"> for {c.courseName}</span></>}
                          icon="fa-solid fa-award"
                          testid="learning-certificate"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
      {data && (data.inProgress || []).length > 0 && (
        <section className="mb-4" aria-labelledby="learning-transcript-going">
          <h2 id="learning-transcript-going" className="h6 text-body-secondary text-uppercase mb-2">
            In progress
          </h2>
          <ul className="list-unstyled mb-0">
            {data.inProgress.map((c) => (
              <li key={c.courseId} className="py-1">
                {c.courseName} <span className="small text-body-secondary">— {statusWord(c.status)}, {c.progressPct ?? 0}%{c.dueAt ? `, due ${formatDue(c.dueAt)}` : ""}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
      {data && (data.history || []).length > 0 && (
        <section aria-labelledby="learning-transcript-history">
          <h2 id="learning-transcript-history" className="h6 text-body-secondary text-uppercase mb-2">
            Earlier training
          </h2>
          <p className="small text-body-secondary mb-2">Completed in AvSight University before Training moved here.</p>
          <ul className="list-unstyled mb-0" data-testid="learning-transcript-history">
            {data.history.map((h, i) => (
              <li key={i} className="py-1">
                {h.title}
                {h.completedAt && <span className="small text-body-secondary"> — {formatDue(h.completedAt)}</span>}
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
